// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3799103b","455":"5fa939d9","977":"49e01660"}[chunkId] + ".chunk.js";
};